// Shared app-wide constants (avoid magic numbers in components).
export const MAX_AVATAR_BYTES = 5 * 1024 * 1024; // 5 Mo
export const MAX_AVATAR_LABEL = "5 Mo";
